/**
 * Public site chrome (header, menu, footer), FR + EN. Editorial copy of the event's public
 * site (canvas "Gravel Games — Site 2027"), kept here rather than in fr.json / en.json because
 * it is structured (lists of links) and long.
 */
export const siteLayout = {
  fr: {
    homeLabel: 'Gravel Games, accueil',
    navLabel: 'Navigation principale',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
    engage: "Je m'engage",
    language: 'Langue',
    nav: [
      { label: 'Le concept', to: '/#concept' },
      { label: 'Épreuves', to: '/#epreuves' },
      { label: 'Embarque ta team', to: '/#embarque' },
      { label: 'Infos pratiques', to: '/#infos' },
      { label: 'Conditions', to: '/conditions' },
      { label: 'FAQ', to: '/#faq' },
    ],
    account: 'Mon espace',
    tagline: 'Un même terrain. Mille façons de le vivre.',
    footLabel: 'Pied de page',
    foot: [
      { label: 'Épreuves', to: '/#epreuves' },
      { label: 'Embarque ta team', to: '/#embarque' },
      { label: 'Infos pratiques', to: '/#infos' },
      { label: 'FAQ', to: '/#faq' },
      { label: 'Conditions de participation', to: '/conditions' },
      { label: 'Règlement sportif', to: '/reglement' },
    ],
    copyright: '© {{year}} Gravel Games',
  },
  en: {
    homeLabel: 'Gravel Games, home',
    navLabel: 'Main navigation',
    openMenu: 'Open the menu',
    closeMenu: 'Close the menu',
    engage: 'Sign up',
    language: 'Language',
    nav: [
      { label: 'The concept', to: '/#concept' },
      { label: 'Events', to: '/#epreuves' },
      { label: 'Bring your crew', to: '/#embarque' },
      { label: 'Practical info', to: '/#infos' },
      { label: 'Requirements', to: '/conditions' },
      { label: 'FAQ', to: '/#faq' },
    ],
    account: 'My account',
    tagline: 'One ground. Many ways to play.',
    footLabel: 'Footer',
    foot: [
      { label: 'Events', to: '/#epreuves' },
      { label: 'Bring your crew', to: '/#embarque' },
      { label: 'Practical info', to: '/#infos' },
      { label: 'FAQ', to: '/#faq' },
      { label: 'Entry requirements', to: '/conditions' },
      { label: 'Sporting rules', to: '/reglement' },
    ],
    copyright: '© {{year}} Gravel Games',
  },
} as const;

export type SiteLayoutContent = (typeof siteLayout)['fr'];
